import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_10_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-10-01",
    "name": "肩袖激活",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "general",
    "tips": ["弹力带外旋内旋", "肩袖肌群预热"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/d590abcf8f6272d7883c5f61.mp4",
    "videoUrl": "/media/collections-20261008/videos/5f1f4f7a98c7c0cb7ba1c410.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第10期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-10-02",
    "name": "实力推",
    "bodyPart": "shoulders",
    "equipment": "barbell",
    "subCategory": "front-deltoid",
    "tips": ["核心收紧", "推举至头顶"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/75ea8997b6fd97e13862ddd0.mp4",
    "videoUrl": "/media/collections-20261008/videos/59f8c90c14ab9706c563924a.mp4",
    "targetMuscles": ["三角肌前束", "三角肌中束", "肱三头肌"],
    "difficulty": "intermediate",
    "source": "焚诀计划 · 第10期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-10-03",
    "name": "仰卧面拉",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "shoulder",
    "tips": ["仰卧位面拉", "后束与肩袖激活"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": false,
    "demoUrl": "/media/collections-20261008/demos/122ea8b189c153c22b55e547.mp4",
    "videoUrl": "/media/collections-20261008/videos/c2a56bd5733aa964c1d30859.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第10期",
    "isStretch": false,
    "demoStatus": "ready",
  },
];
